import { __read } from "tslib";
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { arrayIncludes, getRegexp } from '@slardar/sdk-template';
import { applyPerformance, applyPerformanceObserver, getDefaultPerformance, getDefaultPerformanceObserver, getDefaultPerformanceTiming, onPageLoad, } from '../../utils';
var RESOURCE_EV_TYPE = 'resource';
var RESOURCE_PERFORMANCE_ENTRY_TYPE = 'resource';
var RESOURCE_IGNORE_TYPES = ['xmlhttprequest', 'fetch', 'beacon'];
export var ResourceMonitor = function (performance, performanceObserver, performanceTiming) {
    if (performance === void 0) { performance = getDefaultPerformance(); }
    if (performanceObserver === void 0) { performanceObserver = getDefaultPerformanceObserver(); }
    if (performanceTiming === void 0) { performanceTiming = getDefaultPerformanceTiming(); }
    if (!performance) {
        return;
    }
    return function (props, cb) {
        var ignoreUrls = props.ignoreUrls, slowSessionThreshold = props.slowSessionThreshold, ignoreTypes = props.ignoreTypes;
        var ignoreRegExp = getRegexp(ignoreUrls);
        var restoreFns = [];
        var report = function (resources, isSlowSession) {
            if (isSlowSession === void 0) { isSlowSession = false; }
            resources = resources.filter(function (entry) {
                return (!arrayIncludes(ignoreTypes !== null && ignoreTypes !== void 0 ? ignoreTypes : RESOURCE_IGNORE_TYPES, entry.initiatorType) && !(ignoreRegExp === null || ignoreRegExp === void 0 ? void 0 : ignoreRegExp.test(entry.name)));
            });
            if (cb && resources.length) {
                resources.forEach(function (r) {
                    cb([
                        {
                            ev_type: RESOURCE_EV_TYPE,
                            payload: r,
                        },
                        isSlowSession,
                    ]);
                });
            }
        };
        var checkSlowSession = function () {
            if (!performanceTiming) {
                return false;
            }
            var timing = performanceTiming.loadEventEnd - performanceTiming.navigationStart;
            return timing > slowSessionThreshold;
        };
        var _a = __read(applyPerformance(performance), 3), getEntriesByType = _a[2];
        var startObserve = function () {
            var _a = __read(applyPerformanceObserver(performanceObserver, function (_entry, i, entries) { return i === 0 && report(entries); }), 2), observe = _a[0], disconnect = _a[1];
            observe(RESOURCE_PERFORMANCE_ENTRY_TYPE);
            restoreFns.push(disconnect);
        };
        onPageLoad(function () {
            report(getEntriesByType(RESOURCE_PERFORMANCE_ENTRY_TYPE), checkSlowSession());
            startObserve();
        });
        var tearDown = function () {
            restoreFns.forEach(function (fn) { return fn(); });
        };
        return [tearDown];
    };
};
//# sourceMappingURL=index.js.map